import * as React from 'react';
export const customerPortalSvg = React.forwardRef(
  function customerPortalSvgInner(props, ref) {
    return /*#__PURE__*/ React.createElement(
      'svg',
      {
        ...props,
        ref: ref,
      },
      /*#__PURE__*/ React.createElement('path', {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'M7.11 3.23a4.006 4.006 0 0 1 1.52-1.153c-.412 1.123-.528 2.36-.528 3.548 0 1.291.172 2.486.47 3.38.25.75.74 1.75 1.667 1.745 2.87-.007 5.261-2.278 5.261-5.125C15.5 2.773 13.102.5 10.225.5A5.241 5.241 0 0 0 6.14 2.442a.625.625 0 1 0 .97.788Zm7.087 3.02c-.223 1.314-1.14 2.417-2.382 2.934.346-.933.479-1.945.523-2.934h1.86ZM11.82 2.068c1.239.518 2.154 1.62 2.377 2.932h-1.86c-.043-.988-.174-2-.517-2.932ZM9.367 5c.047-.979.122-2.32.765-3.134.085-.108.104-.108.19 0 .643.815.717 2.155.765 3.134h-1.72Zm0 1.25c.047.979.122 2.32.765 3.134.083.106.102.107.185 0 .643-.815.721-2.153.77-3.134h-1.72ZM1.75 7.5A2.754 2.754 0 0 1 4.5 4.75 2.754 2.754 0 0 1 7.25 7.5a2.754 2.754 0 0 1-2.75 2.75A2.754 2.754 0 0 1 1.75 7.5ZM4.5 6.25c-.687 0-1.25.563-1.25 1.25s.563 1.25 1.25 1.25 1.25-.563 1.25-1.25-.563-1.25-1.25-1.25ZM1.5 16h6A1.5 1.5 0 0 0 9 14.5V14a3 3 0 0 0-3-3H3a3 3 0 0 0-3 3v.5A1.5 1.5 0 0 0 1.5 16Zm6-1.5V14A1.5 1.5 0 0 0 6 12.5H3A1.5 1.5 0 0 0 1.5 14v.5h6Z',
      }),
    );
  },
);
customerPortalSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var customerPortal = {
  category: 'icon',
  colorable: true,
  name: 'customerPortal',
  svg: customerPortalSvg,
};
